import AppDispatcher from '../dispatcher/AppDispatcher';
import {
  CLEAR_DISPUTE_FORM_DATA,
  DISPLAY_REVIEW_SCREEN,
  HANDLE_SUBMIT_DISPUTE_CASE_FAILURE,
  HANDLE_SUBMIT_DISPUTE_CASE_SUCCESS,
  RESET_REFUND_DETAILS,
  SET_DISPUTE_JOURNEY_TYPE,
  SET_EXPECTED_SERVICE_START_DATE,
  SET_EXPECTED_TRAVEL_DEPARTURE_DATE,
  SET_EXPECTED_TRAVEL_RETURN_DATE,
  SET_GOODS_DESCRIPTION_TEXT,
  SET_GOODS_EXPECTED_DELIVERY_DATE,
  SET_PARTIAL_REFUND_AMOUNT,
  SET_REFUND_TYPE,
  SET_SELLER_CONTACT_DATE,
  SET_SELLER_CONTACT_DESCRIPTION_TEXT,
  SET_SERVICE_DESCRIPTION_TEXT,
  SET_TRAVEL_DESCRIPTION_TEXT,
  SUBMIT_DISPUTE_CASE,
} from '../constants/FraudAndDisputeConstants';

class FraudAndDisputeActionCreator {
  submitDisputeCase(caseDetails) {
    AppDispatcher.handleViewAction({
      actionType: SUBMIT_DISPUTE_CASE,
      caseDetails,
    });
  }

  handleSubmitDisputeCaseSuccess(response) {
    AppDispatcher.handleViewAction({
      actionType: HANDLE_SUBMIT_DISPUTE_CASE_SUCCESS,
      response,
    });
  }

  handleSubmitDisputeCaseFailure(error, status) {
    AppDispatcher.handleViewAction({
      actionType: HANDLE_SUBMIT_DISPUTE_CASE_FAILURE,
      errorMessage: error,
      statusCode: status,
    });
  }
  setRefundType(type) {
    AppDispatcher.handleViewAction({
      actionType: SET_REFUND_TYPE,
      type,
    });
  }
  setPartialRefundAmount(amount) {
    AppDispatcher.handleViewAction({
      actionType: SET_PARTIAL_REFUND_AMOUNT,
      amount,
    });
  }
  setDisputeJourneyType(journeyType) {
    AppDispatcher.handleViewAction({
      actionType: SET_DISPUTE_JOURNEY_TYPE,
      journeyType,
    });
  }
  setGoodsExpectedDeliveryDate(expectedDeliveryDate) {
    AppDispatcher.handleViewAction({
      actionType: SET_GOODS_EXPECTED_DELIVERY_DATE,
      expectedDeliveryDate,
    });
  }
  setGoodsDescriptionText(descriptionText) {
    AppDispatcher.handleViewAction({
      actionType: SET_GOODS_DESCRIPTION_TEXT,
      descriptionText,
    });
  }
  setSellerContactDate(sellerContactDate) {
    AppDispatcher.handleViewAction({
      actionType: SET_SELLER_CONTACT_DATE,
      sellerContactDate,
    });
  }
  setSellerContactDescriptionText(descriptionText) {
    AppDispatcher.handleViewAction({
      actionType: SET_SELLER_CONTACT_DESCRIPTION_TEXT,
      descriptionText,
    });
  }
  clearDisputeFormData() {
    AppDispatcher.handleViewAction({
      actionType: CLEAR_DISPUTE_FORM_DATA,
    });
  }
  setExpectedTravelDepartureDate(expectedDepartureDate) {
    AppDispatcher.handleViewAction({
      actionType: SET_EXPECTED_TRAVEL_DEPARTURE_DATE,
      expectedDepartureDate,
    });
  }
  setExpectedTravelReturnDate(expectedReturnDate) {
    AppDispatcher.handleViewAction({
      actionType: SET_EXPECTED_TRAVEL_RETURN_DATE,
      expectedReturnDate,
    });
  }
  setTravelDescriptionText(descriptionText) {
    AppDispatcher.handleViewAction({
      actionType: SET_TRAVEL_DESCRIPTION_TEXT,
      descriptionText,
    });
  }
  displayReviewScreen(value) {
    AppDispatcher.handleViewAction({
      actionType: DISPLAY_REVIEW_SCREEN,
      shouldDisplayReviewScreen: value,
    });
  }
  setExpectedServiceStartDate(expectedStartDate) {
    AppDispatcher.handleViewAction({
      actionType: SET_EXPECTED_SERVICE_START_DATE,
      expectedStartDate,
    });
  }
  setServiceDescriptionText(descriptionText) {
    AppDispatcher.handleViewAction({
      actionType: SET_SERVICE_DESCRIPTION_TEXT,
      descriptionText,
    });
  }
  resetRefundDetails() {
    AppDispatcher.handleViewAction({
      actionType: RESET_REFUND_DETAILS,
    });
  }
}

export default new FraudAndDisputeActionCreator();
